import React, { useState, useEffect } from 'react';
import { Table, Card, Row, Col, Statistic, Rate, DatePicker, Select, Button, Typography } from 'antd';
import { feedbackService } from '../../../services/next';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Title } = Typography;

const QuanLyDanhGiaDichVu = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({ totalReviews: 0, averageRating: 0, rateDistribution: [] });
  // API trả kèm danh sách tính năng (bảng lichviet.features) để bộ lọc hiện tên thay vì bắt gõ ID
  const [features, setFeatures] = useState([]);
  const [filters, setFilters] = useState({ feature_id: null, rate: null, from_date: null, to_date: null });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    total: 0,
    // Lọc theo số sao xong phải thấy ngay có bao nhiêu bản ghi loại đó
    showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} trong tổng số ${total} bản ghi`,
  });

  const fetchData = async (page = 1, pageSize = pagination.pageSize, currentFilters = filters) => {
    setLoading(true);
    try {
      const res = await feedbackService.getList({ 
          page, 
          limit: pageSize, 
          ...currentFilters 
      });
      if (res && res.data) {
        setData(res.data);
        setStats(res.statistics || { totalReviews: 0, averageRating: 0, rateDistribution: [] });
        if (Array.isArray(res.features)) setFeatures(res.features);
        setPagination({ ...pagination, current: page, pageSize, total: res.totalItem });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1, pagination.pageSize, filters);
  }, [filters]);

  const handleTableChange = (newPagination) => {
    fetchData(newPagination.current, newPagination.pageSize, filters);
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    // feature_name do API map từ bảng features; feature đã xoá thì rơi về hiện ID cho dễ tra
    { title: 'TÍNH NĂNG', dataIndex: 'feature_name', key: 'feature_name', width: 180, render: (n, r) => n || (r.feature_id ? `#${r.feature_id}` : '-') },
    { title: 'KHÁCH HÀNG', dataIndex: 'full_name', key: 'full_name', width: 150 },
    { title: 'SỐ ĐIỆN THOẠI', dataIndex: 'phone', key: 'phone', width: 120 },
    // Bảng feedbacks không có cột user_id — cms.next hiện `create_by` dưới nhãn "User"
    { title: 'USER ID', dataIndex: 'create_by', key: 'create_by', width: 100, render: (v) => v ?? '-' },
    { title: 'ĐÁNH GIÁ', dataIndex: 'rate', key: 'rate', width: 150, render: (s) => <Rate disabled defaultValue={s} style={{ fontSize: 14 }} /> },
    { title: 'NỘI DUNG', dataIndex: 'message', key: 'message' },
    { title: 'BÀI VIẾT', dataIndex: 'content_id', key: 'content_id', width: 100 },
    { title: 'NGÀY TẠO', dataIndex: 'create_time', key: 'create_time', width: 140, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
  ];

  return (
    <Card 
      title={<Title level={4} style={{ margin: 0 }}>ĐÁNH GIÁ DỊCH VỤ</Title>}
    >
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col span={8}>
                <Card bordered={false} style={{ background: '#f0f2f5' }}>
                    <Statistic title="Tổng số phản hồi" value={stats.totalReviews} />
                </Card>
            </Col>
            <Col span={8}>
                <Card bordered={false} style={{ background: '#f0f2f5' }}>
                    <Statistic title="Điểm dịch vụ trung bình" value={stats.averageRating} suffix="/ 5" />
                </Card>
            </Col>
        </Row>

        <div style={{ marginBottom: 16, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            <Select
                allowClear
                showSearch
                placeholder="Tính năng"
                style={{ minWidth: 200 }}
                value={filters.feature_id}
                onChange={(val) => setFilters({ ...filters, feature_id: val ?? null })}
                options={features}
                optionFilterProp="label"
            />
            <Select 
                mode="multiple"
                allowClear 
                placeholder="Số sao" 
                style={{ minWidth: 150 }}
                value={filters.rate}
                onChange={(val) => setFilters({ ...filters, rate: val })}
            >
                {[1, 2, 3, 4, 5].map(s => <Select.Option key={s} value={s}>{s} sao</Select.Option>)}
            </Select>
            <RangePicker 
                onChange={(dates) => {
                    if (dates) {
                        setFilters({ 
                            ...filters, 
                            // Trọn ngày theo giờ VN (toISOString() làm mất ngày cuối và lệch múi giờ)
                            from_date: dates[0].startOf('day').format('YYYY-MM-DDTHH:mm:ss+07:00'),
                            to_date: dates[1].endOf('day').format('YYYY-MM-DDTHH:mm:ss+07:00')
                        });
                    } else {
                        setFilters({ ...filters, from_date: null, to_date: null });
                    }
                }}
            />
            <Button onClick={() => setFilters({ feature_id: null, rate: null, from_date: null, to_date: null })}>Xóa bộ lọc</Button>
        </div>

      <Table 
        columns={columns} 
        dataSource={data} 
        rowKey="id" 
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </Card>
  );
};

export default QuanLyDanhGiaDichVu;
